export const protectedStarredCategories = ['Другие', 'Others']
